import React from 'react';
import './../../style/Insta.css';
import image from './../../images/logo.png'
import insta from './../../images/insta/insta.jpg'

//Extracting Components
function ImageInsta(props) {

    //insta link
    function handleClick(e) {
        e.preventDefault();
        console.log('The link was clicked.');
    }

    return (
        <div onClick={handleClick}>
            {/* <img className="test"
                src={props.src}
            /> */}
        </div>
    );
}

class Insta extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           items: [
               {id: 1, item: insta},
               {id: 2, item: insta},
               {id: 3, item: insta},
               {id: 4, item: insta},
               {id: 5, item: insta},
               {id: 6, item: insta},
               {id: 7, item: insta},
               {id: 8, item: insta},
               {id: 9, item: insta}
           ]
        }
   }

    render() {
        return (
            <div className="insta-section">
                <div className="insta-section-area">
                    <div className="profile-area">
                        <div className="profile-img">
                            <img src={image} alt="img"/>
                        </div>
                        <div className="profile-info">
                            <h1>meongcagram</h1>
                            <p>멍카😘🇰🇷💗🐕😍 멍카 멍카그램 🐶🐾❤️💕</p>
                            <p>しろ こいぬ カメラにおさめる 我们的小宝贝！ - 我爱你们！</p>
                            <p> I love all dogs. Thank you so much for following me on Instagram.</p>
                        </div>
                    </div>
                    <div className="photo-list">
                        {this.state.items.map((item,i) =>
                            <ImageInsta src={item.item} key={item.id}/>
                        )}
                    </div>
                </div>
            </div>
        )
    }

}

export default Insta;


// WEBPACK FOOTER //
// ./src/components/container/Insta.js